const {Paragraph, TextRun} = require("docx");

function processNodes(nodes, listLevel = 0) {
    const result = [];

    nodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) {
        switch (node.tagName) {
        case "P":
            if(node.tagName === "P"){
                const children = parseInline(node);
                result.push(
                    new Paragraph({
                        children
                    })
                );
            }
            break;

        case "UL":
            node.childNodes.forEach((li) => {                
                if (li.tagName === "LI") {                  
                    // Recursively check for nested lists inside the <li>
                    li.childNodes.forEach((child) => {
                        if (child.tagName === "UL") {
                            const nested = processNodes(
                            [child],
                            listLevel + 1
                            );
                            result.push(...nested);
                        } 
                        if(child.tagName === "P"){
                            const children = parseInline(child);
                            result.push(
                            new Paragraph({
                                children,
                                bullet: { level: listLevel }
                            })
                            );
                        }
                    });
                }
            });
            break;

        default:
            break;
        }
    }
    });

    return result;
}

function parseInline(element) {
    const runs = [];
    runs.push(
        new TextRun({
            text: element.textContent,
            font: "Calibri",
            size: 22,
        }))
    return runs;
}

export { processNodes }